'use client';

import Image from 'next/image';

const AboutSection = () => {
  return (
    <section id='about' 
      className="w-full bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/images/empower-ai.webp')" }}
    >
      <div className="w-full max-w-[1440px] mx-auto px-[20px] sm:px-[75px] md:px-[100px] py-[30px]">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-0">
          {/* Text Content */}
          <div className="flex flex-col gap-[13px] sm:gap-[19px] md:gap-[26px] w-full lg:flex-1">
            <h2 className="text-[29px] sm:text-[44px] md:text-[59px] font-extrabold leading-[32px] sm:leading-[48px] md:leading-[64px] text-left text-text-darkest w-full lg:w-[68%]">
              What makes EmpowHER in AI unique
            </h2>
            <p className="text-base sm:text-lg md:text-lg font-normal leading-[21px] sm:leading-[25px] md:leading-[29px] text-left text-text-light w-full lg:w-[70%]">
              Unlike traditional panels, EmpowHER in AI is a community-first movement. We build lasting connections and bring together women who are leading the AI narrative.
            </p>
          </div>

          {/* Image */}
          <div className="hidden sm:block w-full lg:w-[34%] flex justify-center lg:justify-end">
            <Image
              src="/images/about-abstract-bg.webp"
              alt="about-abstract-bg"
              width={428}
              height={448}
              className="w-[214px] h-auto sm:w-[321px] md:w-[428px] object-contain"
              unoptimized
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection